import { Club } from "../models/club";

export async function fetchClubSettings(chainId: string, lang: string): Promise<Club[]> {
  const url = `${import.meta.env.VITE_BE_API_DOMAIN}clubs/${chainId}/${lang}`;

  const response = await fetch(url);
  if (!response.ok) throw new Error('Failed to fetch club settings data');
  return response.json();
}
